var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgClinicManagementFocus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1219_97939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 16.6667V11.6667H13.3334V16.6667H15.8334V3.33341H4.16671V16.6667H6.66671ZM8.33337 16.6667H11.6667V13.3334H8.33337V16.6667ZM17.5 16.6667H19.1667V18.3334H0.833374V16.6667H2.50004V2.50008C2.50004 2.27907 2.58784 2.06711 2.74412 1.91083C2.9004 1.75455 3.11236 1.66675 3.33337 1.66675H16.6667C16.8877 1.66675 17.0997 1.75455 17.256 1.91083C17.4122 2.06711 17.5 2.27907 17.5 2.50008V16.6667ZM9.16671 6.66675V5.00008H10.8334V6.66675H12.5V8.33342H10.8334V10.0001H9.16671V8.33342H7.50004V6.66675H9.16671Z",
    fill: "#216AE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1219_97939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgClinicManagementFocus);
export default __webpack_public_path__ + "static/media/svg_clinic_management_focus.c94f8ee91e9c1f0683dc5a26345a529f.svg";
export { ForwardRef as ReactComponent };